import { TextareaField } from '#app/components/form/textarea-field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly value: string
	readonly errors: readonly string[]
	readonly onChange: (value: string) => void
}

export function LabelChangeWorkflowSection({
	resources,
	value,
	errors,
	onChange,
}: Props) {
	return (
		<Section
			title="Label change workflow"
			description="Document the steps so auditors and partners see a controlled review process."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<TextareaField
				labelProps={{
					children:
						'What is the workflow for requesting and executing label updates?',
				}}
				textareaProps={{
					name: 'labelChangeProcess',
					value,
					onChange: (event) => onChange(event.target.value),
					rows: 4,
				}}
				descriptionProps={{
					children:
						'Outline stages (request, design, regulatory review, proofing, print release) and systems used. Helps demonstrate control during audits.',
				}}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
		</Section>
	)
}
